<script setup>
// Aplicativos em tela cheia (menu lateral → Aplicativos): o mesmo iframe da
// aba da conversa (CamadaDeAplicativos), então o que a pessoa abriu numa
// continua na outra. Com mais de um aplicativo, as abas ficam no topo.
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import PalcoDoAplicativo from './PalcoDoAplicativo.vue';
import messages from './i18n';

const props = defineProps({
  appId: { type: [String, Number], default: null },
});

const { t } = useI18n({ messages });
const store = useStore();
const router = useRouter();

const apps = computed(() => store.getters['dashboardApps/getRecords']);
const carregando = computed(
  () => store.getters['dashboardApps/getUIFlags'].isFetching
);
const atual = computed(
  () =>
    apps.value.find(app => String(app.id) === String(props.appId)) ||
    apps.value[0]
);

onMounted(() => {
  if (!apps.value.length) store.dispatch('dashboardApps/get');
});

const abre = app =>
  router.push({ name: 'neuxs_aplicativos', params: { appId: app.id } });
</script>

<template>
  <section class="flex flex-col w-full h-full min-h-0 bg-n-surface-1">
    <nav
      v-if="apps.length > 1"
      class="flex gap-1 px-3 pt-2 overflow-x-auto border-b border-n-weak"
    >
      <button
        v-for="app in apps"
        :key="app.id"
        type="button"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm border-b-2 whitespace-nowrap"
        :class="
          atual?.id === app.id
            ? 'border-n-blue-9 text-n-slate-12'
            : 'border-transparent text-n-slate-11 hover:text-n-slate-12'
        "
        @click="abre(app)"
      >
        <span class="i-lucide-app-window size-4" />
        {{ app.title }}
      </button>
    </nav>
    <div v-if="carregando && !apps.length" class="flex justify-center py-10">
      <Spinner />
    </div>
    <p v-else-if="!atual" class="p-6 m-0 text-sm text-n-slate-11">
      {{ t('NEUXS_APLICATIVOS.NENHUM') }}
    </p>
    <PalcoDoAplicativo v-else :key="atual.id" :app="atual" class="flex-1" />
  </section>
</template>
